import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-policy',
  templateUrl: './quality-policy.component.html',
  styleUrls: ['./quality-policy.component.scss']
})
export class QualityPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
